<template>
    <div :class="[
        'slider',
        `slider--controls-${this.controlsPlacement}`
    ]">
        <div class="swiper-container slider__container" ref="slider">
            <div class="swiper-wrapper">
                <slot></slot>
            </div>
        </div>
        <div class="slider__wrapper">
            <div class="slider__controls" v-if="this.$slots.default && this.$slots.default.length > 1">
                <button v-if="buttons" class="slider__nav-btn slider__nav-btn--prev" ref="prev">
                    <z-icon
                        name="arrow_bold"
                        dir="left"
                    />
                </button>
                <div v-if="pagination" class="slider__pagination" ref="pagination"></div>
                <button v-if="buttons" class="slider__nav-btn slider__nav-btn--next" ref="next">
                    <z-icon
                        name="arrow_bold"
                        dir="right"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'
import { mixinDevice } from '@/utils/mixin'
export default {
    name: 'slider',
    mixins: [mixinDevice],
    data () {
        return {
            slider: undefined,
            activeIndex: 0
        }
    },
    props: {
        lastEmpty: {
            type: Boolean,
            default: false
        },
        effect: {
            type: String,
            default: 'slide'
        },
        buttons: {
            type: Boolean,
            default: true
        },
        pagination: {
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Boolean,
            default: false
        },
        loop: {
            type: Boolean,
            default: false
        },
        speed: {
            type: String,
            default: '5000'
        },
        slidesPerView: {
            type: [Number, String],
            default: 1
        },
        controlsPlacement: {
            type: String,
            default: 'left',
            validator: prop => ['center', 'left'].includes(prop)
        },
        spaceBetween: {
            type: Number,
            default: 0
        }
    },
    methods: {
        init () {
            const _this = this

            let options = {
                allowTouchMove: false,
                observer: true,
                observeParents: true,
                loop: this.loop,
                navigation: {
                    prevEl: this.$refs.prev,
                    nextEl: this.$refs.next
                },
                spaceBetween: this.spaceBetween,
                effect: this.effect,
                pagination: {
                    clickable: true,
                    el: this.$refs.pagination
                },
                on: {
                    slideChange () {
                        _this.activeIndex = this.activeIndex
                    }
                }
            }

            if (this.slidesPerView !== 1) {
                options.slidesPerView = this.slidesPerView

                options.breakpoints = {
                    1023: {
                        slidesPerView: 1
                    },
                    1359: {
                        slidesPerView: 2
                    }
                }
            }

            if (this.autoplay) {
                options.autoplay = {
                    delay: this.speed
                }
            }

            this.slider = new Swiper(this.$refs.slider, options)
            if (_this.lastEmpty) {
                const lastItem = [..._this.$refs.pagination.children].pop()
                _this.$refs.pagination.removeChild(lastItem)
                this.slider.on('slideChange', function () {
                    if ((this.activeIndex + 1) * parseInt(this.params.slidesPerView) >= this.slides.length) {
                        _this.$refs.next.classList.add('swiper-button-disabled')
                    } else if ((_this.device === 'v-tablet' || _this.device === 'mobile') && (this.activeIndex + 1) * parseInt(this.params.slidesPerView) + 1 >= this.slides.length) {
                        _this.$refs.next.classList.add('swiper-button-disabled')
                    } else {
                        _this.$refs.next.classList.remove('swiper-button-disabled')
                    }
                })
            }
        }
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="scss">
.slider {
    $parent: &;
    position: relative;
    width: 100%;

    @include breakpoint (mobile) {
        width: auto;
    }

    &__wrapper {
        max-width: 1920px;
        width: 100%;
        position: relative;
        margin: auto;
    }

    &__controls {
        display: flex;
        margin-top: $token-spacers-s;
    }

    &--controls-left {
        #{$parent}__controls {
            justify-content: flex-start;

            @include breakpoint (mobile) {
                justify-content: center;
            }
        }
    }

    &--controls-center {
        #{$parent}__controls {
            justify-content: center;
        }
    }

    &__nav-btn {
        pointer-events: all;
        transition: all $transition;
        cursor: pointer;
        background-color: transparent;
        appearance: media-slider;
        border: none;
        outline: none;

        svg {
            width: 24px;
            height: 24px;

            @include breakpoint (mobile) {
                width: 20px;
                height: 20px;
            }
        }

        path {
            fill: #0C2952;
        }

        &--prev {
            @include margin-level(right, S);

            &:hover {
                transform: translateX(-2px);
            }
        }

        &--next {
            @include margin-level(left, S);

            &:hover {
                transform: translateX(2px);
            }
        }

        &.swiper-button-disabled {
            pointer-events: none;
            path {
                fill: #09449D;
                opacity: 0.2;
            }
        }
    }

    &__pagination {
        display: flex;
        align-items: center;

        .swiper-pagination-bullet {
            border-radius: 4px;
            background: #09449D;
            width: 8px;
            height: 8px;
            transition: all $transition;

            &:not(:last-child) {
                @include margin-level(right, XS);
            }

            &-active {
                background: #0C2952;
                width: 100px;

                @include breakpoint (mobile) {
                    width: 32px;
                }
            }
        }
    }

    .swiper-slide {
        &__content,
        &__wrapper {
            height: 100%;
        }

        .z-image {
            display: block;

            &__img {
                display: block;
                width: 100%;
            }
        }
    }
}
</style>
